const selectors = {
  getSavedTariffs: state => state.latarnik.get('fetchedTariffs'),
  getLoadingTariffs: state => state.latarnik.get('isLoadingTarriffs'),
  getLoadingControlConfig: state =>
    state.latarnik.get('isLoadingControlConfig'),
  getSavedControlConfig: state => state.latarnik.get('fetchedControlConfig'),
  getSavedControlBox: state => state.latarnik.get('fetchedControlBox')
};
export default selectors;
